import axios from './api'

export const globalSettingsApi = {
  // Get all settings (admin only)
  getAllSettings: async () => {
    const response = await axios.get('/global-settings')
    return response.data
  },

  // Get specific setting
  getSetting: async (key) => {
    const response = await axios.get(`/global-settings/${key}`)
    return response.data
  },

  // Create new setting (admin only)
  createSetting: async (settingData) => {
    const response = await axios.post('/global-settings', settingData)
    return response.data
  },

  // Update setting (admin only)
  updateSetting: async (key, settingData) => {
    const response = await axios.put(`/global-settings/${key}`, settingData)
    return response.data
  },

  // Delete setting (admin only)
  deleteSetting: async (key) => {
    const response = await axios.delete(`/global-settings/${key}`)
    return response.data
  },

  // Get public settings (no auth required)
  getPublicSettings: async () => {
    const response = await axios.get('/global-settings/public')
    return response.data
  }
}

export default globalSettingsApi
